import TextareaAutosize from 'react-textarea-autosize';

interface PromptFieldProps {
  id: string;
  label: string;
  value: string;
  autoFocus?: boolean;
  placeholder?: string;
  onChange: (value: string) => void;
}

export function PromptField({
  id,
  label,
  value,
  autoFocus,
  placeholder,
  onChange,
}: PromptFieldProps) {
  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={id} className="text-[15px] leading-[1.65] text-gray-700">
        {label}
      </label>
      <TextareaAutosize
        id={id}
        value={value}
        autoFocus={autoFocus}
        placeholder={placeholder}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        style={{ resize: 'none' }}
        className="ml-[-8px] max-h-[30vh] w-[calc(100%+8px)] overflow-y-auto border-none px-2 py-2 font-light text-gray-950 outline-none placeholder:text-gray-500 focus:bg-[rgba(0,0,0,0.015)] focus:ring-0 focus:outline-none focus-visible:ring-0 focus-visible:outline-none"
        minRows={2}
      />
    </div>
  );
}
